// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../styles/global.module.css\"","darkPurple":"rgba(62, 15, 72, 1)","select":"style_select__20foD"};